import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import RequireAuth from '../../hoc/RequireAuth'
import { useSession } from '../../store/sessionContext'
import { publicRoutes } from '../publicRoutes'
import { authRoutes } from '../authRoutes'
import { privateRoutes } from '../privateRoutes'

export default function AppRouter() {
  const { session, loading } = useSession()

  if (loading) return null

  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas para todos */}
        {publicRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}

        {/* Rutas públicas exclusivas para usuarios NO logueados */}
        {!session &&
          authRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))
        }

        {/* Redirigir a login si no hay sesión */}
        {!session && <Route path="*" element={<Navigate to="/login" />} />}

        {/* Rutas privadas */}
        {session && (
          <Route element={<RequireAuth />}>
            {/* Redirige / a /home */}
            <Route path="/" element={<Navigate to="/offices" replace />} />

            {/* Renderiza rutas privadas con layout */}
            {privateRoutes.map(({ element, children }, index) => (
              <Route key={index} element={element}>
                {children.map(({ path, element }) => (
                  <Route key={path} path={path} element={element} />
                ))}
              </Route>
            ))}

            {/* Evita volver a login estando logueado */}
            {authRoutes.map(({ path }) => (
              <Route key={path} path={path} element={<Navigate to="/offices" replace />} />
            ))}

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/offices" replace />} />
          </Route>
        )}
      </Routes>
    </BrowserRouter>
  )
}

